/* ==========================================================================
   NSG Framework
   Component : NSG Visual Experience
   Version   : 2.0
   Before / After Slider
   ========================================================================== */

(() => {
  'use strict';

  const viewers = document.querySelectorAll('.nsg-ve__viewer');

  if (!viewers.length) return;

  viewers.forEach((viewer) => {

    const after = viewer.querySelector('.nsg-ve__after');
    const divider = viewer.querySelector('.nsg-ve__divider');
    const handle = viewer.querySelector('.nsg-ve__handle');

    if (!after || !divider || !handle) return;

    let dragging = false;

    const updatePosition = (clientX) => {

      const rect = viewer.getBoundingClientRect();

      let position = (clientX - rect.left) / rect.width;

      position = Math.max(0, Math.min(1, position));

      const percentage = position * 100;

      after.style.width = `${percentage}%`;
      divider.style.left = `${percentage}%`;

    };

    const startDrag = (e) => {

      dragging = true;

      viewer.classList.add('is-dragging');

      updatePosition(
        e.touches ? e.touches[0].clientX : e.clientX
      );

    };

    const moveDrag = (e) => {

      if (!dragging) return;

      updatePosition(
        e.touches ? e.touches[0].clientX : e.clientX
      );

    };

    const endDrag = () => {

      dragging = false;

      viewer.classList.remove('is-dragging');

    };

    handle.addEventListener('mousedown', startDrag);
    viewer.addEventListener('mousedown', startDrag);

    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('mouseup', endDrag);

    handle.addEventListener(
      'touchstart',
      startDrag,
      { passive: true }
    );

    viewer.addEventListener(
      'touchstart',
      startDrag,
      { passive: true }
    );

    window.addEventListener(
      'touchmove',
      moveDrag,
      { passive: true }
    );

    window.addEventListener(
      'touchend',
      endDrag
    );

  });

})();